import {BackendApi} from "../api.ts";
import {BankAccountData, CustomerBankAccount} from "./CustomerBankAccount.ts";

export class CustomerBankAccountRepository {
    private api: BackendApi;

    constructor(api: BackendApi) {
        this.api = api;
    }

    public async getAllBankAccounts(): Promise<Array<CustomerBankAccount>> {
        const rawResult = await this.api.get('customer-bank-account', {});
        const jsonResult = await rawResult.json();

        const result: CustomerBankAccount[] = [];
        for (const rawItem of jsonResult) {
            result.push(CustomerBankAccount.fromApiResponse(rawItem));
        }

        return result;
    }

    public async getMyBankAccounts(): Promise<Array<CustomerBankAccount>> {
        const response = await this.api.BankAccount__myBankAccounts({})

        const result: CustomerBankAccount[] = [];
        for (const rawItem of response) {
            result.push(CustomerBankAccount.fromApiResponse(rawItem as BankAccountData));
        }

        return result;
    }
}
